import React, { useState, useEffect } from "react";
import Loader from "../shared/Loader";
import { isAzaform } from "helpers/brand";

const fetchPosts = async () => {
  const POST_CATEG = isAzaform ? 19 : 5;
  try {
    const response = await fetch(
      `https://hosting.azasoftware.com/wp-json/wp/v2/posts?categories=${POST_CATEG}&_embed`
    );

    return await response.json();
  } catch (error) {
    console.error("Error fetching posts:", error);
  }
};

const Blog = ({ type, className }) => {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    // Add canonical link for Central Feedback blog
    if (isAzaform) return undefined;

    const canonicalHref = "https://centralfeedback.com/blog/";
    const head = document.head;
    if (!head) return undefined;

    let link = head.querySelector('link[rel="canonical"]');
    const didCreate = !link;

    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      head.appendChild(link);
    }

    link.setAttribute("href", canonicalHref);

    return () => {
      // Only remove the link if we created it
      if (didCreate && link && link.parentNode) link.parentNode.removeChild(link);
    };
  }, []);

  useEffect(() => {
    let isMounted = true;
    const getPosts = async () => {
      const posts = await fetchPosts();
      if (isMounted) {
        setArticles(posts);
      }
    };
    getPosts();
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <article className="blog blog">
      <div className="blog__header">
        <p className="date">Articles</p>
        <h1 className="container">
          Welcome to the {isAzaform ? "AzaForm" : "Central Feedback"} blog
        </h1>
        <p className="author">
          We post articles about how and why you should use your free online forms.
        </p>
      </div>
      <main className="container">
        {!articles || (articles.length === 0 && <Loader size="large" />)}
        {articles.map((article) => (
          <a
            key={article.id}
            href={`/blog/${article.slug}`}
            className={`article-link ${
              type === "small" && "article-link--small"
            }`}
          >
            <article className="">
              {article._embedded && article._embedded["wp:featuredmedia"] && (
                <div
                  style={{
                    backgroundImage: `url(${article._embedded["wp:featuredmedia"][0].source_url})`,
                  }}
                  alt={article.title.rendered}
                  className="article-link__image"
                />
              )}
              <h2 className="article-link__title">{article.title.rendered}</h2>
            </article>
          </a>
        ))}
      </main>
    </article>
  );
};

Blog.defaultProps = {
  type: "",
  className: "",
};

export default Blog;
